import React from 'react'

import { useTranslation } from 'next-i18next'

import * as S from './SubHeading.styles'

export const SubHeading = ({ number }: { number: string }) => {
  const { t } = useTranslation()

  if (number) {
    return (
      <>
        {t('b2c.mfa_verifyphone.subheading')}
        <S.Number>{number}</S.Number>
      </>
    )
  }

  return null
}
